import { useEffect, useState } from 'react';
import useToast from 'components/hooks/useToast';
import { fetchGitTeamsDistinctions } from 'common/services/git-teams.service';

const useTotalSummaryDiff = ({ sensorAuthId, orgName, selectedTeams }) => {
  const [summaryDiff, setSummaryDiff] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const fetchSummaryDiff = async () => {
    try {
      setIsLoading(true);
      const summaryDiffRes = await fetchGitTeamsDistinctions(
        sensorAuthId,
        orgName,
        selectedTeams.map(team => team.id)
      );
      setSummaryDiff(summaryDiffRes);
      setIsLoading(false);
    } catch (e) {
      toast({
        message: 'Failed to fetch summary. Please try again later.',
        variant: 'error'
      });
    }
  };

  useEffect(() => {
    fetchSummaryDiff();
  }, []);

  return {
    summaryDiff,
    fetchSummaryDiff,
    isLoading
  };
};

export default useTotalSummaryDiff;
